import { render, staticRenderFns } from "./toolsbar.vue?vue&type=template&id=26c19a50&scoped=true"
import script from "./toolsbar.vue?vue&type=script&lang=js"
export * from "./toolsbar.vue?vue&type=script&lang=js"
import style0 from "./toolsbar.vue?vue&type=style&index=0&id=26c19a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c19a50",
  null
  
)

export default component.exports